import {dynamicRateRoutine} from './dynamicRateActions';

async function dynamicRate(_: ReturnType<typeof dynamicRateRoutine.trigger>, {extra, dispatch}: AppEffectAPI) {
    const result = await extra.fetchDynamicRates().catch(e => {
        dispatch(dynamicRateRoutine.failure(e));
        throw e;
    });

    if (result.status === 'Abort') {
        return;
    }

    dispatch(dynamicRateRoutine.success(result.json));
}

export default function (startListening: AppStartListening) {
    startListening({actionCreator: dynamicRateRoutine.trigger, effect: dynamicRate});
}
